import React, { useEffect, useState } from 'react'
import { Space ,Table,Tag} from 'antd'
import BalanceElseAdd from './BalanceElseAdd'
import BalanceElseEdit from './BalanceElseEdit'
import BalanceElseDel from './BalanceElseDel'
import BalanceElseAudit from './BalanceElseAudit'
import LedgerBalanceCheck from '../ledger/LedgerBalanceCheck'
import ArapCheck from '../../finance/arap/ArapCheck'
import FundCheck from '../fund/FundCheck'
import Main from '../../cpn/Main'
import { useIncomeExpenditureListQuery } from '../../store/BnsKeJiApi'

function BalanceElseList(props) {
    const {data,isSuccess} = useIncomeExpenditureListQuery({
        eie_e_id:localStorage.getItem('e_id'),
        eie_state:'2',
    },{refetchOnMountOrArgChange:1})    
    const [list, setList] = useState();    
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                const newArr = data.Result.map(item => {
                    const {eie_id:key,eie_type_id,eie_arrive_year,eie_egg_value,eie_arrive_month,eie_arrive_day,eie_finance_sub_type_name,eie_hx_ctime,ed_name,eie_jbr_uname,eie_audit1_ctime,eie_audit1_uname,eie_audit2_ctime,eie_audit2_uname,eie_hx_year,eie_hx_month,eie_hx_day,eie_amount,ec_name,eie_ebn_id,eie_content,eie_uname,eie_ctime,eie_update_ctime,eie_update_uname,eie_price,eie_image_file,eie_count,eci_name,eg_name,eu_name,eie_hx_number,eie_bank_log_id,eie_yw_name,ebn_team_num,eie_bank_ctime} = item;
                    let type = ''
                        switch (eie_type_id) {
                            case '1'://销售收入
                            type = '团队收入'
                                break;
                            case '2'://成本支出
                            type = '团队支出'
                                break;
                            case '3'://费用支出
                            type = '费用支出'
                                break;
                            case '4'://其他收入
                            type = '其他收入'
                                break;
                            case '5'://其他支出
                            type = '其他支出'
                                break;              
                            default:
                                break;
                        }
                    return item = {key,eie_type_id,eie_arrive_year,eie_egg_value,eie_arrive_month,eie_arrive_day,eie_finance_sub_type_name,eie_hx_ctime,ed_name,eie_jbr_uname, eie_audit1_ctime,eie_audit1_uname,eie_audit2_ctime,eie_audit2_uname,eie_hx_year,eie_hx_month,eie_hx_day,eie_amount,ec_name,eie_ebn_id,eie_content,eie_uname,eie_ctime,eie_update_ctime,eie_update_uname,eie_price,eie_image_file,eie_count,eci_name,eg_name,eu_name,eie_hx_number,eie_bank_log_id,eie_yw_name,type,ebn_team_num,eie_bank_ctime}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.eie_ctime;
                    let bTimeString = b.eie_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
                
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    const columns = [
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key',           
        },        
        {
            key: 'eie_finance_sub_type_name',
            title: '类型',
            dataIndex: 'eie_finance_sub_type_name',
            render:(text,record) => {
                return record.type + ' - ' + text
            }
        },  
        {
            key: 'client',
            title: '客户',
            dataIndex: 'ec_name',
        },                           
        {
            key: 'eie_amount',
            title: '金额',
            dataIndex: 'eie_amount',
            render:(text) => {
                if(text<0){
                    return <span style={{color:'green',fontSize:"16px"}}>{text}</span>
                }else{
                    return <span style={{color:'red',fontSize:"16px"}}>{text}</span>
                }
            }
        },                      
        {
            key: 'eie_content',
            title: '备注',
            dataIndex: 'eie_content',
        },  
        {
            key: 'eie_yw_name',
            title: '销售员',
            dataIndex:'eie_yw_name',
        },             
                                                 
        {
            key: 'ed_name',
            title: '部门',
            dataIndex: 'ed_name'
        },                                          
                                                
        {
            key: 'status',
            title: '审核',
            render:(_,record) => {
                return<>
                    {!record.eie_audit1_uname && <>待审核</>}
                    {(record.eie_audit1_uname && !record.eie_audit2_uname) && <Tag color='green'>已审核</Tag>}
                    {record.eie_audit2_uname && <Tag color="volcano">已复核</Tag>}
                </>
            }
        },             
        {
            key: 'hx',
            title: '下账核销',
            render:(_,record) => {
                return<>
                    {record.eie_hx_ctime  && <ArapCheck eie_hx_number={record.eie_hx_number} titleType='数字'/>}
                </>
            },
            width:'6%'
        },      
        {
            key: 'zz',
            title: '转账记录',
            render:(_,record) => {
                return<>
                    {record.eie_bank_ctime && <FundCheck ecal_id={record.eie_bank_log_id}  titleType='数字'/>}
                </>
            },
            width:'6%'
        },      
             
        // {
        //     key: 'time',
        //     title: '操作记录',
        //     render: (_,record) => {
        //         return <>
        //             <div>新建时间：{record.eie_ctime + record.eie_uname}</div>
        //             <div>修改时间：{record.eie_update_ctime + record.eie_update_uname}</div>
        //         </>
        //     }
        // },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                     <Space>
                        <LedgerBalanceCheck
                            eie_id={record.key}
                            title={props.main_type_name}
                            jbr_label={props.jbr_label}
                            eie_jbr_uname={props.eie_jbr_uname} 
                            eie_esv_id={props.eie_esv_id}
                            eie_jbr_uid={props.eie_jbr_uid}
                            eie_type_id={record.eie_type_id}
                            eie_finance_sub_type_id={record.eie_finance_sub_type_id}
                            eie_finance_sub_type_name={record.eie_finance_sub_type_name}
                            eie_ebn_id={props.eie_ebn_id}
                            eie_eg_id={props.ebn_eg_id}
                            guige={props.guige}
                        />
                        <BalanceElseEdit 
                            eie_id={record.key}                            
                            eie_audit1_ctime={record.eie_audit1_ctime}
                            eie_hx_ctime={record.eie_hx_ctime}
                            efst_finance_type_id={props.main_type_id}
                            main_type_name={props.main_type_name}
                        />
                        <BalanceElseDel 
                            eie_audit1_ctime={record.eie_audit1_ctime}
                            eie_hx_ctime={record.eie_hx_ctime}
                            eie_id={record.key}
                        />
                        <BalanceElseAudit
                            eie_audit1_ctime={record.eie_audit1_ctime}
                            eie_audit2_ctime={record.eie_audit2_ctime}
                            eie_id={record.key}
                        />
                    </Space>
                </>
            }
        },
    ]
    return (
        <Main t1='业务账' t2='收支流水'>
            <Space>
                <BalanceElseAdd 
                    efst_finance_type_id={props.main_type_id}
                    main_type_name={props.main_type_name}
                />
            </Space>
            <Table 
                    columns={columns} 
                    dataSource={list}  
                    style={{marginTop:"10px"}}   
                    pagination={{
                        pageSize:20,
                        showSizeChanger:true,
                        showTotal:(total) => `共${total}条`,
                    }}            
            />
        </Main>
    )
}

export default BalanceElseList